let count = -1;
class SwiperSlideshow extends HTMLElement {
  constructor() {
    super();
    this.scrollBar = this.querySelector(".swiper-scrollbar");
      this.init();
  }
  connectedCallback() {}
  init() {
    new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 320,
      scrollbar: {
        el: this.scrollBar,
        draggable: true,
        hide: false,
      },
    });
  }
}

if (!customElements.get("swiper-slideshow")) {
  customElements.define("swiper-slideshow", SwiperSlideshow);
}
